import {loadScript} from "@/utils/http";

const loadUMD = async dependency => {
    const {url, target} = dependency.source;

    // if source of the library already in cache do nothing
    if (window[dependency.id]) {
        return;
    }

    // load the data from the source
    await loadScript({url});

    // get the target
    let data = window[target];
    if (!data) {
        throw Error(`Cannot find the target ${target} loaded for dependency ${dependency.id}`);
    }
    delete window[target];

    // set the data into the dependency id
    window[dependency.id] = data;

    // now the code should be available via import in other apps declaring <dependency.id> as external
    // import {<content>} from "<dependency.id>";
};

export default loadUMD;
